import { Id } from '../types'

import { PaywallError } from './PaywallError'

export class TreeCycleError extends PaywallError {
  constructor(id: Id) {
    super(`Tree contains cycle with block ${id}`)
  }
}
